export default __webpack_public_path__ + "static/media/Vigortouch Harness.13e11d6b.jpg";